import { render, staticRenderFns } from "./ModifPwd.vue?vue&type=template&id=42b5ddb2&"
import script from "./ModifPwd.vue?vue&type=script&lang=js&"
export * from "./ModifPwd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports